import { StringParam, useQueryParam, withDefault } from "use-query-params";

import { DEFAULT_SORT } from "../table/components/table-sorter";

export const useTableSort = () => {
  return useQueryParam(
    "pt-table-sort",
    withDefault(StringParam, DEFAULT_SORT),
    {
      updateType: "pushIn",
    },
  );
};
